import { Component, Listen } from '@stencil/core';

@Component({
  tag: 'mama-toggle-offcanvas',
})
export class MamaToggleOffcanvas {
  @Listen('click')
  onClick() {
    document.body.classList.remove('offcanvas-search-active');
    document.body.classList.toggle('offcanvas-active');
  }
}
